import React from "react"
import { Field } from "../../field"
import { FieldWithSubtext } from "./field-with-subtext"
import { AddressFieldWithHiddenInputs } from "./address-field-with-hidden-inputs"
import { CheckboxesForCompetitionMarketingForm } from "./checkboxes-for-competition-marketing-form"
import { PrivacyPolicyLink } from "./privacy-policy-link"
import { StepFieldsProps } from "../../../types/cms/competition-marketing-form"

export const StepFields = (props: StepFieldsProps) => {
  const {
    fieldName,
    fields,
    form,
    formCheckboxes,
    showTermsAndConditionsLink,
    applyAddressToFormMarketing,
    stepContent
  } = props

  switch (fieldName) {
    case 'firstname':
      return <Field {...fields.firstName} showAsterisk inputGroupProps={{style: {maxWidth: 450}}} />
    
    case 'lastname':
      return (
        <FieldWithSubtext
          subtext={stepContent?.stepperFormSubtext?.nameFieldSubtext}
          hasError={!!form.formState.errors.lastname}
        >
          <Field {...fields.lastName} showAsterisk inputGroupProps={{style: {maxWidth: 450}}} />
        </FieldWithSubtext>
      )
    
    case 'email':
      return (
        <FieldWithSubtext
          subtext={stepContent?.stepperFormSubtext?.emailFieldSubtext}
          hasError={!!form.formState.errors.email}
        >
          <Field {...fields.email} showAsterisk inputGroupProps={{style: {maxWidth: 450}}} />
        </FieldWithSubtext>
      )
    
    case 'phone':
      return (
        <FieldWithSubtext
          subtext={stepContent?.stepperFormSubtext?.phoneFieldSubtext}
          hasError={!!form.formState.errors.phone}
        >
          <Field {...fields.phone} showAsterisk inputGroupProps={{style: {maxWidth: 450}}} />
        </FieldWithSubtext>
      )
    
    case 'address':
      return (
        <AddressFieldWithHiddenInputs
          field={fields.address}
          form={form}
          applyAddressToFormMarketing={applyAddressToFormMarketing}
          hasError={!!form.formState.errors.address}
          subtext={stepContent?.stepperFormSubtext?.addressFieldSubtext}
        />
      )
    
    case 'checkboxes':
      return (
        <>
          <CheckboxesForCompetitionMarketingForm
            form={form}
            formCheckboxes={formCheckboxes}
          />
          {showTermsAndConditionsLink && <PrivacyPolicyLink />}
        </>
      )
    
    default:
      return null
  }
}